import { CreateTimeOffRequestRequest } from '../types/dto/create-time-off-request.dto';
import { TimeOffRequestFormValues } from '../validations/time-off-request-form.schema';
import { mapTimeOffWorkingDaysToDto } from './time-off-request-form-payload.mapper';

/**
 * Builds the create payload from the create form values. Non-working days are
 * dropped and calendar dates are normalized to start-of-day UTC (timezone-safe).
 * `idempotencyId` is intentionally omitted — the backend auto-generates one.
 */
export const buildCreateRequestPayload = (
  values: TimeOffRequestFormValues
): CreateTimeOffRequestRequest => ({
  timeOffTypeId: Number(values.timeOffTypeId),
  description: values.description.trim() || undefined,
  days: mapTimeOffWorkingDaysToDto(values.days),
  approverIds: values.approvers.map(approver => approver.id),
});
